module.exports = __webpack_public_path__ + "static/img/10.01e2c01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/10.jpg
// module id = /ZfH
// module chunks = 0